import baseMockModel from 'libs/mock/baseMockModel'
class mockArticle extends baseMockModel {
  item() {
    let item = {
      id: this.faker.random.number(),
      name: this.faker.internet.userName(),
      created_at: helper.moment(this.faker.date.past()).format('YYYY-MM-DD HH:mm:ss'),
      updated_at: helper.moment(this.faker.date.past()).format('YYYY-MM-DD HH:mm:ss'),
    }

    return item
  }

  list() {
    return this.createList({ max: 5, min: 5 })
  }

  index(params) {
    return this.createIndex({ max: 10, min: 10, page: params.page || 1 })
  }
}

export default new mockArticle()